export default __webpack_public_path__ + "static/media/PricesLarge.32721cb1.png";